import { Button, Group, Modal, Stack, Text, TextInput } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface DoubleConfirmDialogProps {
  opened: boolean;
  /** the literal text the user must type to enable confirm */
  expected: string;
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DoubleConfirmDialog({
  opened,
  expected,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}: DoubleConfirmDialogProps) {
  const { t } = useTranslation('common');
  const [value, setValue] = useState('');
  const matches = value.trim() === expected.trim();

  const handleClose = () => {
    setValue('');
    onCancel();
  };

  const handleConfirm = () => {
    if (!matches) return;
    setValue('');
    onConfirm();
  };

  return (
    <Modal opened={opened} onClose={handleClose} title={title ?? t('confirm.delete.title')} centered>
      <Stack>
        <Text>{message ?? t('confirm.delete.message')}</Text>
        <Text fw={600}>{expected}</Text>
        <TextInput
          label={t('confirm.delete.placeholder')}
          value={value}
          onChange={(e) => setValue(e.currentTarget.value)}
          error={value && !matches ? t('confirm.delete.error') : null}
          autoFocus
          aria-required="true"
        />
        <Group justify="flex-end">
          <Button variant="default" onClick={handleClose}>
            {cancelLabel ?? t('actions.cancel')}
          </Button>
          <Button color="red" disabled={!matches} onClick={handleConfirm}>
            {confirmLabel ?? t('actions.delete')}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
